<template>

    <div id='table-row'>
        <div class="row-data" id="rank">#<slot name="rank"></slot></div>
         <div class="row-data" id="name"><slot name="name"></slot></div>
          <div class="row-data"><slot name="sport"></slot></div>
          <div class="row-data" id="count">
              <slot name="count"></slot>
            </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>

#table-row{
    background:$row-grey;
    width:100%;
    min-height:60px;
    color:$blue;
    font-weight:bold;
    font-size: 16px;
    height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-top:10px;
}

.row-data {
    width:90px;
    margin:5px;
}

#name{
    display:flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
    flex-wrap: wrap;
    width:150px;
     @include respond(phone-only) {
        width:90px;
     }
}

#count {

    height:30px;
    background-color:darkgrey;
    border: 1px $blue solid;
    display:flex;
    justify-content: flex-start;
    align-items: center;
    
}

#inner-bar{
    height:30px;
    background-color:$red2;
    width:50%;
     @include transition(width 2s ease-in-out);
}

#score{
    color:$white;
    margin-left:10px;
    margin-top:4px;
}


</style>